import { useTranslation } from "react-i18next";
import LoadingIndicator from "../LoadingIndicator";
import { Link } from "react-router-dom";
import PlanSummary from "./PlanSummary";

const PaymentStatusContent = ({
  status,
  errorMessage,
  onTryAgain,
  invoiceDetails,
  isFlatPricing
}) => {
  const { t } = useTranslation("signup");

  return (
    <>
      <div className="auth-header">
        <div className="cs-container">
          <div className="left">
            <Link to="/" className="left">
              <img src={"/images/business-logo.svg"} alt="" />
            </Link>
          </div>
        </div>
      </div>

      <div className="payment-status-content-wrapper">
        <div className="payment-status-content thankyou-page-summary">
          <div className="payment-success-layout">
            <div className="summary-column">
               <PlanSummary 
                invoiceDetails={invoiceDetails}
                status={status}
                isFlatPricing={isFlatPricing}
               />
            </div>

            <div className="success-message-column">
              {(status === "processing" || status === "polling") && (
                <>
                  <LoadingIndicator />
                  <h3>{t("confirming_payment", "تأكيد الدفع")}</h3>
                  <div className="subtitle success-notes">
                    <p style={{ color: "#b0b0ba" }}>
                      {t(
                        "confirming_payment_note",
                        "يرجى الانتظار بينما نقوم بالتحقق من عملية الدفع",
                      )}
                    </p>
                  </div>
                </>
              )}

              {status === "verification" && (
                <>
                  <div className="status-icon pending" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
                      <rect width="80" height="80" rx="40" fill="#F79E1B" />
                      <circle cx="40" cy="40" r="16" stroke="white" strokeWidth="4" />
                      <path d="M40 28v12l8 8" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <h3>{t("payment_under_verification_title", "الدفعة قيد التحقق")}</h3>
                  <div className="subtitle success-notes">
                    <p style={{ whiteSpace: "pre-line" }}>
                      {t("payment_under_verification_note", "لقد استلمنا طلب الدفع الخاص بك.\nقد يستغرق التأكيد بضع دقائق.\nستتلقى بريدًا إلكترونيًا بمجرد التحقق من الدفع.")}
                    </p>
                  </div>

                  <button
                    className="btn go-home-btn"
                    onClick={() => (window.location.href = "/")}
                  >
                    {t("go_to_home", "الذهاب للرئيسية")}
                  </button>
                </>
              )}

              {status === "success" && (
                <>
                  <div className="status-icon success">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="80"
                      height="80"
                      viewBox="0 0 80 80"
                      fill="none"
                    >
                      <rect width="80" height="80" rx="40" fill="#51CAAD" />
                      <path
                        d="M22 40.1579L33.3684 52L57.3684 28"
                        stroke="white"
                        strokeWidth="6"
                      />
                    </svg>
                  </div>
                  <h3>{t("payment_success_title", "عملية دفع ناجحة")}</h3>
                  <div className="subtitle success-notes">
                    <p>
                      {t(
                        "payment_success_note_4",
                        "يرجى التحقق من بريدك الإلكتروني للحصول على التعليمات التفصيلية حول كيفية الوصول إلى نظام إدارة التعلم، وتعيين كلمة مرور الآدمن، ودعوة فريقك.",
                      )}
                    </p>
                  </div>

                  <button
                    className="btn go-home-btn"
                    onClick={() => (window.location.href = "/")}
                  >
                    {t("go_to_home", "الذهاب للرئيسية")}
                  </button>
                </>
              )}

              {status === "error" && (
                <>
                  <div className="status-icon error">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="96"
                      height="96"
                      viewBox="0 0 96 96"
                      fill="none"
                    >
                      <rect width="96" height="96" rx="48" fill="#BE1622" />
                      <path
                        d="M32 32L64 64M64 32L32 64"
                        stroke="white"
                        strokeWidth="6"
                        strokeLineCap="round"
                        strokeLineJoin="round"
                      />
                    </svg>
                  </div>
                  <h3>
                    {t("payment_failed_title", "لقد حدث خطأ بعملية الدفع")}
                  </h3>
                  <div className="subtitle success-notes">
                    <p>
                      {errorMessage ||
                        t(
                          "payment_failed_note",
                          "للأسف لم تكتمل عملية الدفع الخاصة بك برجاء المحاولة في وقت آخر",
                        )}
                    </p>
                  </div>

                  <div className="d-flex gap-3 align-items-center justify-content-center">
                    {onTryAgain && (
                      <button
                        className="btn go-home-btn btn-light"
                        onClick={onTryAgain}
                      >
                        {t("try_again", "حاول مرة أخرى")}
                      </button>
                    )}
                    <button
                      className="btn go-home-btn"
                      onClick={() => (window.location.href = "/")}
                    >
                      {t("go_to_home", "الذهاب للرئيسية")}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentStatusContent;
